export default __webpack_public_path__ + "images/project_fallback_image-pz7Gl.png";